import ModalContentComponent, {
	ModalContentComponentProps,
} from './ModalContentComponent';
export type { ModalContentComponentProps };
export default ModalContentComponent;
